(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setAnnouncementBarHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setAnnouncementBarHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.createAnnouncementBarObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setAnnouncementBarHeight() {
      const announcementBar = document.querySelector('.announcement-bar-section');
      if (announcementBar) {
        if (announcementBar.classList.contains('announcement-bar-hidden')) {
          document.documentElement.style.setProperty('--announcement-bar-height', '0px');
        } else {
          document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBar.offsetHeight}px`);
        }
      } else {
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.announcementBarObserver) {
        this.announcementBarObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    createAnnouncementBarObserver() {
      const announcementBar = document.querySelector('.announcement-bar-section');
      if (announcementBar) {
        this.announcementBarObserver = new MutationObserver(() => {
          this.setAnnouncementBarHeight();
        });

        this.announcementBarObserver.observe(announcementBar, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (function () {
    'use strict';

    // FIX: Track bound listeners to avoid accumulation on re-renders
    var originalInputListeners = new WeakMap();

    function renderCaracteristicasFilters() {
      // New type-filter bar uses data-top-filter — skip old clone logic
      if (document.querySelector('[data-top-filter="type"]')) return;

      var newSubmenu = document.querySelector('.product-type-submenu');
      if (!newSubmenu) return;

      var productTypeSubmenu =
        document.querySelector('.filter-type-caracterisiticas') ||
        document.querySelector('[data-type="filter-type-caracterisiticas"]') ||
        document.querySelector('#FacetFiltersFormMobile .js-filter[data-type="filter-type-caracterisiticas"]') ||
        document.querySelector('#FacetFiltersForm .js-filter[data-type="filter-type-caracterisiticas"]');

      if (!productTypeSubmenu) {
        console.log('Caracterisiticas filter not found');
        return;
      }

      // Clear existing content (removes old cloned nodes and their listeners)
      newSubmenu.innerHTML = '';

      var duplicatedMenu = productTypeSubmenu.cloneNode(true);

      duplicatedMenu.querySelectorAll('input').forEach(function (input) {
        var originalId = input.getAttribute('id');

        if (originalId) {
          input.setAttribute('data-original-id', originalId);
          input.setAttribute('id', originalId + '_duplicate');
        }

        input.removeAttribute('name');

        var value = input.getAttribute('value');
        if (value && value.includes(',')) {
          input.setAttribute('value', value.replace(/,\s*$/, '').trim());
        }

        // FIX: Use named functions so listeners can be identified and not stack
        function onDuplicateChange() {
          var label = input.closest('.mobile-facets__label');
          if (input.checked) {
            input.classList.add('checked');
            if (label) label.classList.add('checked');
          } else {
            input.classList.remove('checked');
            if (label) label.classList.remove('checked');
          }

          var originalInput = document.querySelector('#' + originalId);
          if (originalInput) {
            originalInput.checked = input.checked;
            originalInput.dispatchEvent(new Event('change', { bubbles: true }));
            originalInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }

        input.addEventListener('change', onDuplicateChange);

        var label = input.closest('.mobile-facets__label') || input.closest('label');
        if (label) {
          label.onclick = null;
          label.addEventListener('click', function () {
            setTimeout(function () {
              var originalInput = document.querySelector('#' + originalId);
              if (originalInput) {
                originalInput.checked = input.checked;
                originalInput.dispatchEvent(new Event('change', { bubbles: true }));
                originalInput.dispatchEvent(new Event('input', { bubbles: true }));
              }
            }, 10);
          });
        }

        // FIX: Remove previous listener on the original before adding a new one
        var originalInput = document.querySelector('#' + originalId);
        if (originalInput) {
          var previousListener = originalInputListeners.get(originalInput);
          if (previousListener) {
            originalInput.removeEventListener('change', previousListener);
          }

          function onOriginalChange() {
            input.checked = originalInput.checked;
            var lbl = input.closest('.mobile-facets__label');
            if (input.checked) {
              input.classList.add('checked');
              if (lbl) lbl.classList.add('checked');
            } else {
              input.classList.remove('checked');
              if (lbl) lbl.classList.remove('checked');
            }
          }

          originalInput.addEventListener('change', onOriginalChange);
          originalInputListeners.set(originalInput, onOriginalChange);
        }

        // Set initial checked state
        if (input.checked) {
          input.classList.add('checked');
          var lbl = input.closest('.mobile-facets__label');
          if (lbl) lbl.classList.add('checked');
        }
      });

      newSubmenu.appendChild(duplicatedMenu);
    }

    /* —— Top Type filters (same behavior as product-grid-with-size-filter) —— */
    function getFacetForms() {
      return [
        document.getElementById('FacetFiltersForm'),
        document.getElementById('FacetFiltersFormMobile'),
      ].filter(Boolean);
    }

    function findFacetInputs(paramName, value) {
      var inputs = [];
      getFacetForms().forEach(function (form) {
        form.querySelectorAll('input[name="' + paramName + '"]').forEach(function (input) {
          if (!value || input.value === value) inputs.push(input);
        });
      });
      return inputs;
    }

    function setActiveLabel(input, isActive) {
      var label = input.closest('.collection-size-filters__label');
      if (!label) return;
      label.classList.toggle('active', isActive);
    }

    function setDisabledLabel(input, isDisabled) {
      var label = input.closest('.collection-size-filters__label');
      if (!label) return;
      input.disabled = !!isDisabled;
      label.classList.toggle('disabled', !!isDisabled);
      if (isDisabled) {
        label.setAttribute('aria-disabled', 'true');
      } else {
        label.removeAttribute('aria-disabled');
      }
    }

    function isFacetOptionDisabled(facetInput) {
      if (!facetInput) return true;
      if (facetInput.disabled) return true;
      var label =
        facetInput.closest('label') ||
        facetInput.closest('.facets__label') ||
        facetInput.closest('.mobile-facets__label');
      if (label && label.classList.contains('disabled')) return true;
      return false;
    }

    function getActiveFacetForm() {
      var mobile = document.getElementById('FacetFiltersFormMobile');
      var desktop = document.getElementById('FacetFiltersForm');
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
        return mobile || desktop;
      }
      return desktop || mobile;
    }

    var isSubmittingTopFilter = false;

    function submitFacetFilters(paramName, selectedValues) {
      findFacetInputs(paramName).forEach(function (facetInput) {
        var shouldCheck = selectedValues.indexOf(facetInput.value) !== -1;
        if (shouldCheck) {
          facetInput.disabled = false;
          var label =
            facetInput.closest('label') ||
            facetInput.closest('.facets__label') ||
            facetInput.closest('.mobile-facets__label');
          if (label) label.classList.remove('disabled');
        }
        facetInput.checked = shouldCheck;
      });

      var form = getActiveFacetForm();
      if (!form || typeof FacetFiltersForm === 'undefined') return false;

      var params = new URLSearchParams(new FormData(form));
      params.delete(paramName);
      selectedValues.forEach(function (value) {
        if (value) params.append(paramName, value);
      });

      if (!params.has('filter.v.availability')) {
        params.set('filter.v.availability', '1');
      }

      isSubmittingTopFilter = true;
      FacetFiltersForm.renderPage(params.toString());
      return true;
    }

    function syncTopFromFacets() {
      document.querySelectorAll('[data-top-filter="type"]').forEach(function (group) {
        var param = group.getAttribute('data-filter-param');
        if (!param) return;

        group.querySelectorAll('input[data-filter-group]').forEach(function (input) {
          var matchedFacetInputs = findFacetInputs(param, input.value);
          var isChecked = matchedFacetInputs.some(function (facetInput) {
            return facetInput.checked;
          });

          var isDisabled = false;
          if (matchedFacetInputs.length > 0) {
            isDisabled =
              !isChecked &&
              matchedFacetInputs.every(function (facetInput) {
                return isFacetOptionDisabled(facetInput);
              });
          }

          input.checked = isChecked;
          setActiveLabel(input, isChecked);
          setDisabledLabel(input, isDisabled);
        });
      });
    }

    function applySingleSelect(groupEl, selectedInput) {
      var param = groupEl.getAttribute('data-filter-param');
      if (!param || !selectedInput) return;

      var shouldUnselect = selectedInput.checked;

      groupEl.querySelectorAll('input[data-filter-group]').forEach(function (input) {
        var shouldCheck = !shouldUnselect && input === selectedInput;
        input.checked = shouldCheck;
        setActiveLabel(input, shouldCheck);
        if (shouldCheck) setDisabledLabel(input, false);
      });

      var selectedValues = shouldUnselect ? [] : [selectedInput.value];

      if (submitFacetFilters(param, selectedValues)) return;

      var changedInput = null;
      findFacetInputs(param).forEach(function (facetInput) {
        var shouldCheck = !shouldUnselect && facetInput.value === selectedInput.value;
        if (shouldCheck) facetInput.disabled = false;
        if (facetInput.checked !== shouldCheck) {
          facetInput.checked = shouldCheck;
          changedInput = facetInput;
        } else {
          facetInput.checked = shouldCheck;
        }
      });

      if (changedInput) {
        changedInput.dispatchEvent(new Event('input', { bubbles: true }));
        changedInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function bindTopFilterClicks() {
      document.querySelectorAll('[data-top-filter="type"]').forEach(function (group) {
        group.querySelectorAll('.collection-size-filters__label').forEach(function (label) {
          if (label.dataset.bound === 'true') return;
          label.dataset.bound = 'true';

          label.addEventListener('click', function (event) {
            event.preventDefault();
            var input = label.querySelector('input[data-filter-group]');
            if (!input || input.disabled || label.classList.contains('disabled')) return;
            applySingleSelect(group, input);
          });
        });
      });
    }

    function initTopTypeFilters() {
      if (!document.querySelector('[data-top-filter="type"]')) return;
      bindTopFilterClicks();
      syncTopFromFacets();
    }

    function init() {
      renderCaracteristicasFilters();
      initTopTypeFilters();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('collection:rendered', function () {
      isSubmittingTopFilter = false;
      renderCaracteristicasFilters();
      initTopTypeFilters();
    });

    document.addEventListener('facet:update', function () {
      syncTopFromFacets();
    });

    var syncAfterFacetRender = function () {
      setTimeout(function () {
        bindTopFilterClicks();
        syncTopFromFacets();
      }, 50);
    };

    if (typeof FacetFiltersForm !== 'undefined') {
      var originalRenderProductGridContainer = FacetFiltersForm.renderProductGridContainer;
      FacetFiltersForm.renderProductGridContainer = function (html) {
        originalRenderProductGridContainer.call(FacetFiltersForm, html);
        syncAfterFacetRender();
      };
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        if (typeof FacetFiltersForm === 'undefined') return;
        var originalRenderProductGridContainer = FacetFiltersForm.renderProductGridContainer;
        FacetFiltersForm.renderProductGridContainer = function (html) {
          originalRenderProductGridContainer.call(FacetFiltersForm, html);
          syncAfterFacetRender();
        };
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid-with-size-filter"]) return;
  try {
    
  (function () {
    'use strict';

    function getFacetForms() {
      return [
        document.getElementById('FacetFiltersForm'),
        document.getElementById('FacetFiltersFormMobile'),
      ].filter(Boolean);
    }

    function findFacetInputs(paramName, value) {
      var inputs = [];
      var normalizedValue = value ? normalizeSizeKey(value) : null;
      getFacetForms().forEach(function (form) {
        form.querySelectorAll('input[name="' + paramName + '"]').forEach(function (input) {
          if (!value) {
            inputs.push(input);
            return;
          }
          if (input.value === value || normalizeSizeKey(input.value) === normalizedValue) {
            inputs.push(input);
          }
        });
      });
      return inputs;
    }

    function setActiveLabel(input, isActive) {
      var label = input.closest('.collection-size-filters__label');
      if (!label) return;
      label.classList.toggle('active', isActive);
    }

    function setDisabledLabel(input, isDisabled) {
      var label = input.closest('.collection-size-filters__label');
      if (!label) return;
      input.disabled = !!isDisabled;
      label.classList.toggle('disabled', !!isDisabled);
      if (isDisabled) {
        label.setAttribute('aria-disabled', 'true');
      } else {
        label.removeAttribute('aria-disabled');
      }
    }

    function getSizeEquivalentsMap() {
      var el = document.getElementById('SizeEquivalentsMap');
      if (!el) return {};
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return {};
      }
    }

    function normalizeSizeKey(value) {
      return String(value || '')
        .trim()
        .toUpperCase()
        .replace(/^TALLA\s+/i, '');
    }

    function getEquivalentsForValue(value) {
      var map = getSizeEquivalentsMap();
      var key = normalizeSizeKey(value);
      if (map[key]) return map[key].slice();

      var found = [key];
      Object.keys(map).forEach(function (alpha) {
        if (map[alpha].indexOf(key) !== -1 || map[alpha].indexOf(String(value)) !== -1) {
          found = map[alpha].slice();
        }
      });
      return found;
    }

    function getSelectedValuesForTopInput(input, groupType) {
      if (groupType === 'size') {
        var fromAttr = (input.getAttribute('data-equivalents') || '').split('|').filter(Boolean);
        if (fromAttr.length) return fromAttr;
        return getEquivalentsForValue(input.getAttribute('data-size-key') || input.value);
      }
      return [input.value];
    }

    function valuesInclude(selectedValues, facetValue) {
      var facetKey = normalizeSizeKey(facetValue);
      return selectedValues.some(function (value) {
        return value === facetValue || normalizeSizeKey(value) === facetKey;
      });
    }

    function isFacetOptionDisabled(facetInput) {
      if (!facetInput) return true;
      if (facetInput.disabled) return true;
      var label =
        facetInput.closest('label') ||
        facetInput.closest('.facets__label') ||
        facetInput.closest('.mobile-facets__label');
      if (label && label.classList.contains('disabled')) return true;
      return false;
    }

    function getActiveFacetForm() {
      var mobile = document.getElementById('FacetFiltersFormMobile');
      var desktop = document.getElementById('FacetFiltersForm');
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
        return mobile || desktop;
      }
      return desktop || mobile;
    }

    var isSubmittingTopFilter = false;

    function submitFacetFilters(paramName, selectedValues) {
      // Keep desktop + mobile facet UIs in sync
      findFacetInputs(paramName).forEach(function (facetInput) {
        var shouldCheck = valuesInclude(selectedValues, facetInput.value);
        if (shouldCheck) {
          // Disabled inputs are omitted from FormData — re-enable selected equivalents
          facetInput.disabled = false;
          var label =
            facetInput.closest('label') ||
            facetInput.closest('.facets__label') ||
            facetInput.closest('.mobile-facets__label');
          if (label) label.classList.remove('disabled');
        }
        facetInput.checked = shouldCheck;
      });

      var form = getActiveFacetForm();
      if (!form || typeof FacetFiltersForm === 'undefined') return false;

      var params = new URLSearchParams(new FormData(form));
      params.delete(paramName);
      selectedValues.forEach(function (value) {
        if (value) params.append(paramName, value);
      });

      if (!params.has('filter.v.availability')) {
        params.set('filter.v.availability', '1');
      }

      isSubmittingTopFilter = true;
      FacetFiltersForm.renderPage(params.toString());
      return true;
    }

    function syncTopFromFacets() {
      document.querySelectorAll('[data-top-filter]').forEach(function (group) {
        var param = group.getAttribute('data-filter-param');
        if (!param) return;

        group.querySelectorAll('input[data-filter-group]').forEach(function (input) {
          var equivalents = (input.getAttribute('data-equivalents') || input.value).split('|').filter(Boolean);
          if (!equivalents.length) equivalents = [input.value];

          var matchedFacetInputs = [];
          equivalents.forEach(function (equiv) {
            matchedFacetInputs = matchedFacetInputs.concat(findFacetInputs(param, equiv));
          });

          var isChecked = matchedFacetInputs.some(function (facetInput) {
            return facetInput.checked;
          });

          // Sync disabled with facets only when matching facet options exist
          var isDisabled = false;
          if (matchedFacetInputs.length > 0) {
            isDisabled =
              !isChecked &&
              matchedFacetInputs.every(function (facetInput) {
                return isFacetOptionDisabled(facetInput);
              });
          }

          input.checked = isChecked;
          setActiveLabel(input, isChecked);
          setDisabledLabel(input, isDisabled);
        });
      });

      // If active type became disabled after a size change, move to first available
      if (!isSubmittingTopFilter) {
        var typeGroup = document.querySelector('[data-top-filter="type"]');
        if (typeGroup) {
          var selectedType = typeGroup.querySelector('input[data-filter-group]:checked');
          if (
            selectedType &&
            (selectedType.disabled || selectedType.closest('.collection-size-filters__label.disabled'))
          ) {
            var firstEnabled = getFirstEnabledInput(typeGroup);
            if (firstEnabled && firstEnabled !== selectedType) {
              applySingleSelect(typeGroup, firstEnabled);
              return;
            }
          }
        }
      }

      syncSizeTitle();
    }

    function syncSizeTitle() {
      var sizeGroup = document.querySelector('[data-top-filter="size"]');
      var titleEl = document.querySelector('.collection-size-filters__title');
      if (!sizeGroup) return;

      var activeSize = sizeGroup.querySelector('input[data-filter-group]:checked');
      var labelText = '';
      if (activeSize) {
        var textEl =
          activeSize.closest('label') &&
          activeSize.closest('label').querySelector('.collection-size-filters__text');
        labelText = textEl ? textEl.textContent.trim() : '';
      }

      if (labelText) {
        if (!titleEl) {
          titleEl = document.createElement('h2');
          titleEl.className = 'collection-size-filters__title';
          var bar = document.querySelector('[data-size-filter-bar]');
          if (bar && bar.parentElement) bar.parentElement.appendChild(titleEl);
        }
        titleEl.textContent = labelText.toUpperCase();
        titleEl.hidden = false;
      } else if (titleEl) {
        titleEl.hidden = true;
      }
    }

    function applySingleSelect(groupEl, selectedInput) {
      var param = groupEl.getAttribute('data-filter-param');
      var groupType = groupEl.getAttribute('data-top-filter');
      if (!param || !selectedInput) return;

      // Clicking the active option unselects it
      var shouldUnselect = selectedInput.checked;

      groupEl.querySelectorAll('input[data-filter-group]').forEach(function (input) {
        var shouldCheck = !shouldUnselect && input === selectedInput;
        input.checked = shouldCheck;
        setActiveLabel(input, shouldCheck);
        if (shouldCheck) setDisabledLabel(input, false);
      });

      var selectedValues = shouldUnselect ? [] : getSelectedValuesForTopInput(selectedInput, groupType);

      if (submitFacetFilters(param, selectedValues)) {
        if (groupType === 'size') syncSizeTitle();
        return;
      }

      // Fallback when FacetFiltersForm is unavailable
      var changedInput = null;
      findFacetInputs(param).forEach(function (facetInput) {
        var shouldCheck = !shouldUnselect && valuesInclude(selectedValues, facetInput.value);
        if (shouldCheck) facetInput.disabled = false;
        if (facetInput.checked !== shouldCheck) {
          facetInput.checked = shouldCheck;
          changedInput = facetInput;
        } else {
          facetInput.checked = shouldCheck;
        }
      });

      if (changedInput) {
        changedInput.dispatchEvent(new Event('input', { bubbles: true }));
        changedInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function bindTopFilterClicks() {
      document.querySelectorAll('[data-top-filter]').forEach(function (group) {
        group.querySelectorAll('.collection-size-filters__label').forEach(function (label) {
          if (label.dataset.bound === 'true') return;
          label.dataset.bound = 'true';

          label.addEventListener('click', function (event) {
            event.preventDefault();
            var input = label.querySelector('input[data-filter-group]');
            if (!input || input.disabled || label.classList.contains('disabled')) return;
            applySingleSelect(group, input);
          });
        });
      });
    }

    function getFirstEnabledInput(group) {
      return group.querySelector('input[data-filter-group]:not(:disabled)');
    }

    function hideNumericFacetSizes() {
      var sizeGroup = document.querySelector('[data-top-filter="size"]');
      if (!sizeGroup) return;
      var param = sizeGroup.getAttribute('data-filter-param');
      if (!param) return;

      var alphaKeys = Object.keys(getSizeEquivalentsMap());
      findFacetInputs(param).forEach(function (input) {
        var key = normalizeSizeKey(input.value);
        var isAlpha = alphaKeys.indexOf(key) !== -1;
        if (isAlpha) return;

        var item = input.closest('li') || input.closest('.mobile-facets__item') || input.closest('.list-menu__item');
        if (item) item.style.display = 'none';
      });
    }

    function bindFacetSizeExpansion() {
      var sizeGroup = document.querySelector('[data-top-filter="size"]');
      if (!sizeGroup) return;
      var param = sizeGroup.getAttribute('data-filter-param');
      if (!param) return;

      findFacetInputs(param).forEach(function (input) {
        if (input.dataset.equivBound === 'true') return;
        input.dataset.equivBound = 'true';

        input.addEventListener(
          'change',
          function () {
            var equivalents = getEquivalentsForValue(input.value);
            if (!equivalents.length) return;

            equivalents.forEach(function (equiv) {
              findFacetInputs(param, equiv).forEach(function (facetInput) {
                if (input.checked) {
                  facetInput.disabled = false;
                  var label =
                    facetInput.closest('label') ||
                    facetInput.closest('.facets__label') ||
                    facetInput.closest('.mobile-facets__label');
                  if (label) label.classList.remove('disabled');
                }
                facetInput.checked = input.checked;
              });
            });
          },
          true
        );
      });
    }

    function init() {
      bindTopFilterClicks();
      bindFacetSizeExpansion();
      hideNumericFacetSizes();
      syncTopFromFacets();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('collection:rendered', function () {
      isSubmittingTopFilter = false;
      bindTopFilterClicks();
      bindFacetSizeExpansion();
      hideNumericFacetSizes();
      syncTopFromFacets();
    });

    document.addEventListener('facet:update', function () {
      bindFacetSizeExpansion();
      hideNumericFacetSizes();
      syncTopFromFacets();
    });

    var syncAfterFacetRender = function () {
      setTimeout(function () {
        bindTopFilterClicks();
        bindFacetSizeExpansion();
        hideNumericFacetSizes();
        syncTopFromFacets();
      }, 50);
    };

    if (typeof FacetFiltersForm !== 'undefined') {
      var originalRenderProductGridContainer = FacetFiltersForm.renderProductGridContainer;
      FacetFiltersForm.renderProductGridContainer = function (html) {
        originalRenderProductGridContainer.call(FacetFiltersForm, html);
        syncAfterFacetRender();
      };
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        if (typeof FacetFiltersForm === 'undefined') return;
        var originalRenderProductGridContainer = FacetFiltersForm.renderProductGridContainer;
        FacetFiltersForm.renderProductGridContainer = function (html) {
          originalRenderProductGridContainer.call(FacetFiltersForm, html);
          syncAfterFacetRender();
        };
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
